import { KeyValue } from '@/main/models/common';
import { CompanyManufacturerRequest } from '@/main/models/request/companyManufacturerRequest';

export enum CompanyManufacturerTypes {
  GET_COMPANY_MANUFACTURER = '@companyManufacturer/GET_COMPANY_MANUFACTURER',
  SAVE_COMPANY_MANUFACTURER = '@companyManufacturer/SAVE_COMPANY_MANUFACTURER',
  RESET_REDUCER_COMPANY_MANUFACTURER = '@companyManufacturer/RESET_REDUCER_COMPANY_MANUFACTURER'
}

export interface CompanyManufacturerState {
  readonly companyManufacturer: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetCompanyManufacturer {
  type: typeof CompanyManufacturerTypes.GET_COMPANY_MANUFACTURER;
  payload: {
    request: CompanyManufacturerRequest;
  };
}

export interface SaveCompanyManufacturer {
  type: typeof CompanyManufacturerTypes.SAVE_COMPANY_MANUFACTURER;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerCompanyManufacturer {
  type: typeof CompanyManufacturerTypes.RESET_REDUCER_COMPANY_MANUFACTURER;
}

export type CompanyManufacturerActionTypes =
  | GetCompanyManufacturer
  | SaveCompanyManufacturer
  | ResetReducerCompanyManufacturer;
